var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mx_is)?_c('div',{staticClass:"opc-cart__description",staticStyle:{"margin-bottom":"0"}},[_vm._v(" "+_vm._s(_vm.$t('billing.order_summary.taxes_desc2'))+" ")]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }